import { useState } from 'react';
import { useToast } from '../../components/ui';

// Encapsula todo el flujo de "cancelar un turno": qué turno está seleccionado,
// el estado de la operación y la confirmación. Recibe la función `cancelar`
// del hook de datos (useTurnosUsuario) para no duplicar la llamada a la API acá.
export function useCancelarTurno(cancelar) {
  const { notify } = useToast();
  const [cancelTarget, setCancelTarget] = useState(null);
  const [cancelError, setCancelError] = useState('');
  const [isCancelling, setIsCancelling] = useState(false);

  const handleCancel = (turno) => {
    setCancelTarget(turno);
    setCancelError('');
  };

  const cerrar = () => setCancelTarget(null);

  const confirmCancel = async () => {
    if (!cancelTarget) return;
    setIsCancelling(true);
    setCancelError('');
    try {
      await cancelar(cancelTarget.id);
      notify('El turno fue cancelado.', { title: 'Turno cancelado' });
      setCancelTarget(null);
    } catch (err) {
      setCancelError(err?.message || 'No se pudo cancelar el turno.');
    } finally {
      setIsCancelling(false);
    }
  };

  return { cancelTarget, cancelError, isCancelling, handleCancel, confirmCancel, cerrar };
}